import { render } from "./CollectionTracks.vue?vue&type=template&id=599d641a"
import script from "./CollectionTracks.vue?vue&type=script&lang=js"
export * from "./CollectionTracks.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__